import * as React from "react";
import Paper from "@mui/material/Paper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import Stack from "@mui/material/Stack";
import PersonIcon from "@mui/icons-material/Person";
import SettingsIcon from "@mui/icons-material/Settings";
import DoneIcon from "@mui/icons-material/Done";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import LogoutIcon from "@mui/icons-material/Logout";
import LabelIcon from "@mui/icons-material/Label";
import { usePosStore } from "../context/posStore";
import { ComponentModal, IProduct } from "../common/interfaces";
import { useModalStore } from "../context/modalStore";
import { CommonService } from "../services/CommonService";

// Cantidad mínima permitida (50 gramos = 0.05 kg)
const MIN_QTY = 0.05;

export interface MenuProps {}

export const MainMenu: React.FC<MenuProps> = () => {
  const modalManager = useModalStore((state) => state);
  const products = usePosStore((state) => state.products);
  const customer = usePosStore((state) => state.customer);
  const order = usePosStore((state) => state.order);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img
        className="img-fluid"
        src={`${process.env.PUBLIC_URL}/img/logo1.png`}
        style={{ width: "100px" }}
        alt="logo"
      />
      <Stack direction="row" spacing={2} marginTop={5}>
        <Paper>
          <MenuList>
            <MenuItem
              className="menuIcons"
              onClick={() => modalManager.openModal(ComponentModal.Customer)}
            >
              <div>
                <PersonIcon />
                <br />
                <div>Clientes</div>
              </div>
            </MenuItem>
            <MenuItem
              className="menuIcons"
              onClick={() => modalManager.openModal(ComponentModal.Utilidades, {})}
            >
              <div>
                <SettingsIcon />
                <br />
                <div>Utilidades</div>
              </div>
            </MenuItem>
            <MenuItem
              className="menuIcons"
              onClick={() => modalManager.openModal(ComponentModal.ProductLabels)}
            >
              <div>
                <LabelIcon />
                <br />
                <div>Etiquetas</div>
              </div>
            </MenuItem>

            <MenuItem
              className="menuIcons"
              onClick={() => modalManager.openModal(ComponentModal.Cancel)}
            >
              <div>
                <DeleteForeverIcon />
                <br />
                <div>Eliminar</div>
              </div>
            </MenuItem>
            <MenuItem
              className="menuIcons"
              onClick={() => {
                if (products.length === 0) {
                  CommonService.toast("No hay productos en la orden", "error");
                  return;
                }
                // Validar que todos los productos tengan cantidad válida (mínimo 0.05 kg)
                const hasInvalidQuantity = products.some(
                  (product: IProduct) => !product.quantity || Number(product.quantity) < MIN_QTY
                );
                if (hasInvalidQuantity) {
                  CommonService.toast("Todos los productos deben tener cantidad mínima de 50 gramos (0.05 kg)", "error");
                  return;
                }
                console.log('🔍 OPENING FINISH MODAL FROM MENU:', {
                  order,
                  orderTotal: order?.total,
                  orderSubtotal: order?.subtotal,
                  orderIva: order?.iva,
                  products,
                  productsLength: products.length,
                  customer,
                  type: 'order',
                });
                modalManager.openModal(ComponentModal.Finish, {
                  order,
                  products,
                  customer,
                  type: 'order',
                  fromPayButton: true, // Indica que se abrió desde el botón pagar
                });
              }}
            >
              <div>
                <DoneIcon />
                <br />
                <div>Pagar (F2)</div>
              </div>
            </MenuItem>
            <MenuItem
              className="menuIcons"
              onClick={() => modalManager.openModal(ComponentModal.LogOut, {
                utilOption: "closeBox",
                title: "Cerrar Sesión",
              })}
            >
              <div>
                <LogoutIcon />
                <br />
                <div>Cerrar Sesión</div>
              </div>
            </MenuItem>
          </MenuList>
        </Paper>
      </Stack>
    </div>
  );
};
